import type {SelectChangeEvent} from '@mui/material';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import type * as React from 'react';
import type {CapacityConfig} from '@/types/CapacityConfig';

const getCurrentCapacityYearMonthOptions = (
    capacityConfig : CapacityConfig,
    currentYearMonthKey : keyof CapacityConfig | undefined,
) : string[] => {
    const keys = Object.keys(capacityConfig);
    const currentMonthIndex = keys.findIndex(k => k === currentYearMonthKey);
    const startIndex = currentMonthIndex > 3 ? currentMonthIndex - 3 : 0;

    return keys.slice(startIndex, startIndex + 12);
};

type Props = {
    defaultCapacityYearMonth : string;
    fiscalMonth : string;
    setFiscalMonth : (fiscalMonth : string) => void;
    capacityConfig : CapacityConfig;
};

const EmployeeCapacityMonthSelection = (
    {
        defaultCapacityYearMonth,
        fiscalMonth,
        setFiscalMonth,
        capacityConfig,
    } : Props
) : React.ReactElement => {
    const currentYearMonthKeyOptions = getCurrentCapacityYearMonthOptions(capacityConfig, defaultCapacityYearMonth);

    const handleChange = (event : SelectChangeEvent) => {
        setFiscalMonth(event.target.value);
    };

    return <FormControl fullWidth>
        <InputLabel id="fiscal-month-label">Fiscal Month</InputLabel>
        {currentYearMonthKeyOptions.length && <Select
            labelId="fiscal-month-label"
            id="fiscal-month"
            value={fiscalMonth}
            label="Fiscal Month"
            onChange={handleChange}
            sx={{
                width: '110px',
            }}
        >
            {currentYearMonthKeyOptions.map(currentYearMonthKeyOption => {
                return <MenuItem
                    value={currentYearMonthKeyOption}
                    key={`fiscal-month-${currentYearMonthKeyOption}`}
                >
                    {currentYearMonthKeyOption}
                </MenuItem>;
            })}
        </Select>}
    </FormControl>;
};

export default EmployeeCapacityMonthSelection;
